// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    //baseUrl: "https://apidev.rvcs.co.in/api",
    baseUrl: 'https://localhost:5006/api',
    googleSetting: {
        clientID:
            '705612332439-6a4o6jgh8m98nsparq453631oth7e8uj.apps.googleusercontent.com',
        projectID: 'sylvan-airship-382408',
        authUrl: 'https://accounts.google.com/o/oauth2/auth',
        tokenUrl: 'https://oauth2.googleapis.com/token',
        auth_provider_x509_cert_url:
            'https://www.googleapis.com/oauth2/v1/certs',
        clientSecret: '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',
        redirectUrl: 'http://localhost:4200/usersettings',
        driveFolderPath: 'https://drive.google.com/drive/folders',
        dcoumentFilePath: 'https://docs.google.com/document/d',
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
